import { Translation } from "./types";

export const translations: Translation = {
  // New Projects Banner
  newProjects: {
    en: "New Projects",
    he: "פרוייקטים חדשים",
    fr: "Nouveaux Projets",
  },

  // Header & Navigation
  brand: {
    en: "Samantha Azoulay Real Estate",
    he: 'סמנטה אזולאי נדל"ן',
    fr: "Samantha Azoulay Immobilier",
  },
  tagline: {
    en: "Your Gateway to Life in Israel",
    he: "השער שלך לחיים בישראל",
    fr: "Votre Porte d'Entrée vers la Vie en Israël",
  },
  properties: {
    en: "Properties",
    he: "נכסים",
    fr: "Propriétés",
  },
  about: {
    en: "About",
    he: "אודות",
    fr: "À Propos",
  },
  agent: {
    en: "Agent",
    he: "סוכנת",
    fr: "Agent",
  },
  contact: {
    en: "Contact",
    he: "צור קשר",
    fr: "Contact",
  },

  // Hero Section
  heroTitle: {
    en: "MAKING ALIYAH TO ISRAEL?",
    he: "עושים עלייה לישראל?",
    fr: "VOUS FAITES VOTRE ALIYAH EN ISRAËL?",
  },
  heroSubtitle: {
    en: "I'm here to guide you through every step of buying or renting a home.",
    he: "אני כאן כדי להדריך אתכם בכל שלב ברכישה או שכירות של בית.",
    fr: "Je suis là pour vous guider à chaque étape de l'achat ou de la location d'une maison.",
  },
  viewProperties: {
    en: "Leave Your Details",
    he: "השאירו פרטים",
    fr: "Laissez Vos Coordonnées",
  },

  // About Section
  aboutDescription: {
    en: "I'm Samantha Azoulay, a licensed real estate agent specializing in helping families make Aliyah to Israel. With over a decade of experience, I understand that moving to a new country is about more than just finding a home-it's about building a new life. I provide comprehensive support throughout your entire journey, from property search and negotiations to legal assistance, bank account setup, and navigating Israeli bureaucracy. Every client receives personalized guidance to ensure a smooth, confident transition to life in Israel.",
    he: `אני סמנטה אזולאי, סוכנת נדל״ן מוסמכת המתמחה בסיוע למשפחות העושות עלייה לישראל. עם למעלה מעשור של ניסיון, אני מבינה שמעבר למדינה חדשה הוא יותר מסתם מציאת בית-זה בניית חיים חדשים. אני מעניקה תמיכה מקיפה לאורך כל המסע שלכם, החל מחיפוש נכסים ומשא ומתן, דרך סיוע משפטי, פתיחת חשבון בנק, ועד ניווט בבירוקרטיה הישראלית. כל לקוח מקבל הדרכה אישית להבטחת מעבר חלק ובטוח לחיים בישראל.`,
    fr: "Je suis Samantha Azoulay, agent immobilier agréé spécialisé dans l'aide aux familles faisant leur Aliyah en Israël. Avec plus d'une décennie d'expérience, je comprends que déménager dans un nouveau pays va au-delà de trouver simplement une maison-il s'agit de construire une nouvelle vie. Je fournis un soutien complet tout au long de votre parcours, de la recherche immobilière et des négociations à l'assistance juridique, l'ouverture de compte bancaire et la navigation dans la bureaucratie israélienne. Chaque client reçoit des conseils personnalisés pour assurer une transition fluide et confiante vers la vie en Israël.",
  },
  whyChooseUs: {
    en: "How I Can Help You",
    he: "איך אני יכולה לעזור לך",
    fr: "Comment Je Peux Vous Aider",
  },
  whyChoosePoint1: {
    en: "Personalized Property Search - Homes that match your lifestyle, needs, and budget.",
    he: "חיפוש נכסים מותאם אישית - בתים שמתאימים לסגנון החיים, הצרכים והתקציב שלך.",
    fr: "Recherche Immobilière Personnalisée - Des maisons qui correspondent à votre style de vie, vos besoins et votre budget.",
  },
  whyChoosePoint2: {
    en: "Smart Negotiation - Professional representation to secure the best price and terms.",
    he: "משא ומתן חכם - ייצוג מקצועי להבטחת המחיר והתנאים הטובים ביותר.",
    fr: "Négociation Intelligente - Représentation professionnelle pour obtenir le meilleur prix et les meilleures conditions.",
  },
  whyChoosePoint3: {
    en: "Legal Support - Access to trusted real-estate attorneys who specialize in smooth, safe transactions.",
    he: "תמיכה משפטית - גישה לעורכי דין מקרקעין מהימנים המתמחים בעסקאות חלקות ובטוחות.",
    fr: "Support Juridique - Accès à des avocats immobiliers de confiance spécialisés dans les transactions fluides et sécurisées.",
  },
  whyChoosePoint4: {
    en: "Renovation & Upgrades - Reliable contractors for remodeling, design, and home improvements.",
    he: "שיפוצים ושדרוגים - קבלנים אמינים לשיפוץ, עיצוב ושיפורי בית.",
    fr: "Rénovation et Améliorations - Entrepreneurs fiables pour la rénovation, la conception et les améliorations domiciliaires.",
  },
  whyChoosePoint5: {
    en: "Bank Account Assistance - Step-by-step help opening an Israeli bank account and understanding all requirements.",
    he: "סיוע בפתיחת חשבון בנק - עזרה שלב אחר שלב בפתיחת חשבון בנק ישראלי והבנת כל הדרישות.",
    fr: "Assistance Bancaire - Aide étape par étape pour ouvrir un compte bancaire israélien et comprendre toutes les exigences.",
  },
  whyChoosePoint6: {
    en: "Complete Aliyah Support - Paperwork, bureaucracy, and everything you need to settle in with confidence.",
    he: "תמיכה מלאה בעלייה - ניירת, ביורוקרטיה וכל מה שאתה צריך כדי להשתקע בביטחון.",
    fr: "Support Aliyah Complet - Paperasse, bureaucratie et tout ce dont vous avez besoin pour vous installer en toute confiance.",
  },
  getInTouch: {
    en: "Get In Touch",
    he: "צור קשר",
    fr: "Prendre Contact",
  },

  // Filters
  filters: {
    en: "Filters",
    he: "סינון",
    fr: "Filtres",
  },
  city: {
    en: "City",
    he: "עיר",
    fr: "Ville",
  },
  allCities: {
    en: "All Cities",
    he: "כל הערים",
    fr: "Toutes les Villes",
  },
  priceRange: {
    en: "Price Range",
    he: "טווח מחירים",
    fr: "Gamme de Prix",
  },
  rooms: {
    en: "Rooms",
    he: "חדרים",
    fr: "Chambres",
  },
  anyRooms: {
    en: "Any",
    he: "כל מספר",
    fr: "Tous",
  },
  propertyType: {
    en: "Type",
    he: "סוג",
    fr: "Type",
  },
  all: {
    en: "All",
    he: "הכל",
    fr: "Tous",
  },
  forSale: {
    en: "For Sale",
    he: "למכירה",
    fr: "À Vendre",
  },
  forRent: {
    en: "For Rent",
    he: "להשכרה",
    fr: "À Louer",
  },
  status: {
    en: "Status",
    he: "סטטוס",
    fr: "Statut",
  },
  available: {
    en: "Available",
    he: "זמין",
    fr: "Disponible",
  },
  sold: {
    en: "Sold",
    he: "נמכר",
    fr: "Vendu",
  },
  rented: {
    en: "Rented",
    he: "מושכר",
    fr: "Loué",
  },
  clearFilters: {
    en: "Clear Filters",
    he: "נקה סינון",
    fr: "Effacer les Filtres",
  },

  // Property Details
  sqm: {
    en: "sqm",
    he: 'מ"ר',
    fr: "m²",
  },
  room: {
    en: "room",
    he: "חדר",
    fr: "chambre",
  },
  roomsCount: {
    en: "rooms",
    he: "חדרים",
    fr: "chambres",
  },
  contactAboutProperty: {
    en: "Contact About This Property",
    he: "פנה לגבי נכס זה",
    fr: "Contacter pour cette Propriété",
  },
  viewDetails: {
    en: "View Details",
    he: "צפה בפרטים",
    fr: "Voir Détails",
  },

  // Views
  listView: {
    en: "List View",
    he: "תצוגת רשימה",
    fr: "Vue Liste",
  },
  mapView: {
    en: "Map View",
    he: "תצוגת מפה",
    fr: "Vue Carte",
  },

  // Contact Form
  name: {
    en: "Name",
    he: "שם",
    fr: "Nom",
  },
  email: {
    en: "Email",
    he: "אימייל",
    fr: "Email",
  },
  phone: {
    en: "Phone",
    he: "טלפון",
    fr: "Téléphone",
  },
  message: {
    en: "Message",
    he: "הודעה",
    fr: "Message",
  },
  send: {
    en: "Send Message",
    he: "שלח הודעה",
    fr: "Envoyer le Message",
  },
  sendMessage: {
    en: "Send Message",
    he: "שלח הודעה",
    fr: "Envoyer le Message",
  },
  sending: {
    en: "Sending...",
    he: "שולח...",
    fr: "Envoi...",
  },
  required: {
    en: "Required",
    he: "נדרש",
    fr: "Requis",
  },
  namePlaceholder: {
    en: "Enter your name",
    he: "הכנס את שמך",
    fr: "Entrez votre nom",
  },
  emailPlaceholder: {
    en: "your.email@example.com",
    he: "your.email@example.com",
    fr: "votre.email@example.com",
  },
  phonePlaceholder: {
    en: "+972-XX-XXX-XXXX",
    he: "+972-XX-XXX-XXXX",
    fr: "+972-XX-XXX-XXXX",
  },
  messagePlaceholder: {
    en: "Tell me about your real estate needs, when you're planning to make Aliyah, or any questions you have...",
    he: 'ספר לי על צרכי הנדל"ן שלך, מתי אתה מתכנן לעשות עלייה, או כל שאלה שיש לך...',
    fr: "Parlez-moi de vos besoins immobiliers, de quand vous prévoyez de faire votre Aliyah, ou de toute question que vous avez...",
  },
  contactFormDescription: {
    en: "Ready to start your journey to Israel? Fill out the form below and I'll get back to you within 24 hours.",
    he: "מוכן להתחיל את המסע שלך לישראל? מלא את הטופס למטה ואחזור אליך תוך 24 שעות.",
    fr: "Prêt à commencer votre voyage vers Israël? Remplissez le formulaire ci-dessous et je vous répondrai dans les 24 heures.",
  },
  contactSuccess: {
    en: "Message sent successfully! I'll get back to you soon.",
    he: "ההודעה נשלחה בהצלחה! אחזור אליך בקרוב.",
    fr: "Message envoyé avec succès! Je vous répondrai bientôt.",
  },
  contactError: {
    en: "Failed to send message. Please try again or contact me directly.",
    he: "שליחת ההודעה נכשלה. אנא נסה שוב או צור איתי קשר ישירות.",
    fr: "Échec de l'envoi du message. Veuillez réessayer ou me contacter directement.",
  },

  // Contact & Footer
  contactDescription: {
    en: "Ready to find your dream home in Israel? Get in touch today for personalized assistance.",
    he: "מוכנים למצוא את בית החלומות שלכם בישראל? צרו קשר היום לקבלת סיוע אישי.",
    fr: "Prêt à trouver votre maison de rêve en Israël? Contactez-nous aujourd'hui pour une assistance personnalisée.",
  },
  followUs: {
    en: "Follow Us",
    he: "עקבו אחרינו",
    fr: "Suivez-Nous",
  },
  officeHours: {
    en: "Office Hours",
    he: "שעות פעילות",
    fr: "Heures d'Ouverture",
  },
  businessHours: {
    en: "Business Hours",
    he: "שעות עסקים",
    fr: "Heures d'Affaires",
  },
  office: {
    en: "Office Location",
    he: "מיקום המשרד",
    fr: "Localisation du Bureau",
  },
  officeAddress: {
    en: "Beni Berman 2, Netanya, Israel",
    he: "בני ברמן 2, נתניה, ישראל",
    fr: "Beni Berman 2, Netanya, Israël",
  },
  viewOnMap: {
    en: "View on Map",
    he: "צפה במפה",
    fr: "Voir sur la Carte",
  },
  clientTestimonials: {
    en: "Client Testimonials",
    he: "המלצות לקוחות",
    fr: "Témoignages Clients",
  },
  readyToStart: {
    en: "Ready to Start Your Journey?",
    he: "מוכנים להתחיל את המסע?",
    fr: "Prêt à Commencer Votre Voyage?",
  },
  readyToStartDescription: {
    en: "Contact Samantha today to discuss your real estate needs and begin your journey to finding the perfect home in Israel.",
    he: 'צרו קשר עם סמנטה היום כדי לדון בצרכי הנדל"ן שלכם ולהתחיל את המסע למציאת הבית המושלם בישראל.',
    fr: "Contactez Samantha aujourd'hui pour discuter de vos besoins immobiliers et commencer votre voyage pour trouver la maison parfaite en Israël.",
  },
  allRightsReserved: {
    en: "© 2026 Samantha Azoulay Real Estate - All rights reserved.",
    he: "© 2026 סמנטה אזולאי נדל\"ן - כל הזכויות שמורות.",
    fr: "© 2026 Samantha Azoulay Immobilier - Tous droits réservés.",
  },
  developedBy: {
    en: "Developed by",
    he: "פותח על ידי",
    fr: "Développé par",
  },
  privacyPolicy: {
    en: "Privacy Policy",
    he: "מדיניות פרטיות",
    fr: "Politique de Confidentialité",
  },
  termsOfService: {
    en: "Terms of Service",
    he: "תנאי שימוש",
    fr: "Conditions d'Utilisation",
  },
  accessibility: {
    en: "Accessibility",
    he: "נגישות",
    fr: "Accessibilité",
  },
  accessibilityStatement: {
    en: "Accessibility Statement",
    he: "הצהרת נגישות",
    fr: "Déclaration d'Accessibilité",
  },
  accessibilityStatementTitle: {
    en: "Accessibility Statement – Samantha Azoulay Real Estate",
    he: 'הצהרת נגישות – סמנטה אזולאי נדל"ן',
    fr: "Déclaration d'Accessibilité – Samantha Azoulay Immobilier",
  },
  accessibilityStatementLastUpdated: {
    en: "Last updated: 25/03/2026",
    he: "עודכן לאחרונה: 25/03/2026",
    fr: "Dernière mise à jour : 25/03/2026",
  },
  accessibilityStatementIntro: {
    en: "Samantha Azoulay Real Estate is committed to making its website accessible to people with disabilities, in accordance with the Equal Rights for Persons with Disabilities Law, 5758-1998, and the regulations enacted thereunder.\n\nWe invest significant resources to provide an equal browsing experience to all users, including those using assistive technologies.",
    he: 'סמנטה אזולאי נדל"ן מחויבת להנגשת האתר לאנשים עם מוגבלויות, בהתאם לחוק שוויון זכויות לאנשים עם מוגבלות, תשנ"ח-1998, והתקנות שהותקנו מכוחו.\n\nאנו משקיעים משאבים רבים על מנת לספק חווית גלישה שוויונית לכל המשתמשים, לרבות אלה המשתמשים בטכנולוגיות מסייעות.',
    fr: "Samantha Azoulay Immobilier s'engage à rendre son site web accessible aux personnes handicapées, conformément à la loi sur l'égalité des droits pour les personnes handicapées de 1998 et aux règlements adoptés en vertu de celle-ci.\n\nNous investissons d'importantes ressources pour offrir une expérience de navigation égale à tous les utilisateurs, y compris ceux utilisant des technologies d'assistance.",
  },
  accessibilitySection1Title: {
    en: "1. Accessibility Level",
    he: "1. רמת הנגישות",
    fr: "1. Niveau d'Accessibilité",
  },
  accessibilitySection1Content: {
    en: "The website strives to conform to the requirements of Israeli Standard 5568 for web content accessibility, based on WCAG 2.1 guidelines at Level AA.\n\nAccessibility adjustments implemented on this site include:\n• Skip-to-main-content link for keyboard users\n• ARIA landmarks (header, main, footer, navigation) for screen reader navigation\n• Text alternatives for non-text content (decorative images and background video are hidden from screen readers)\n• Full keyboard navigability for all interactive elements, including navigation, forms, image carousel, and star rating\n• Sufficient color contrast ratio (≥4.5:1) for all body text and UI labels\n• Dynamic language attribute (lang) and text direction (dir) updated per selected language, with full right-to-left (RTL) support for Hebrew\n• Resizable text without loss of content or functionality\n• Clear and consistent navigation with accessible names on all buttons and controls\n• Descriptive ARIA labels on image carousel navigation and property image indicators\n• Star rating implemented as a radio button group for full assistive-technology compatibility\n• Form fields with visible labels\n• Multi-language support: English, Hebrew (RTL), and French",
    he: "האתר שואף לעמוד בדרישות התקן הישראלי 5568 לנגישות תכני אינטרנט, המבוסס על הנחיות WCAG 2.1 ברמה AA.\n\nהתאמות הנגישות המיושמות באתר כוללות:\n• קישור \"דלג לתוכן הראשי\" למשתמשי מקלדת\n• ציוני דרך ARIA (header, main, footer, navigation) לניווט קורא מסך\n• חלופות טקסט לתכנים לא-טקסטואליים (תמונות ווידאו דקורטיביים מוסתרים מקוראי מסך)\n• ניווט מלא באמצעות מקלדת לכל הרכיבים האינטראקטיביים, כולל ניווט, טפסים, קרוסלת תמונות ודירוג כוכבים\n• ניגודיות צבעים מספקת (≥4.5:1) לכל טקסט גוף ותוויות ממשק\n• עדכון דינמי של תכונת השפה (lang) וכיוון הטקסט (dir) בהתאם לשפה הנבחרת, עם תמיכה מלאה בכתיבה מימין לשמאל (RTL) לעברית\n• שינוי גודל טקסט ללא איבוד תוכן או פונקציונליות\n• ניווט ברור ועקבי עם שמות נגישים על כל הכפתורים והפקדים\n• תוויות ARIA תיאוריות על ניווט קרוסלת תמונות ומחוואני תמונות נכסים\n• דירוג כוכבים מיושם כקבוצת כפתורי רדיו לתאימות מלאה עם טכנולוגיות מסייעות\n• שדות טופס עם תוויות גלויות\n• תמיכה רב-לשונית: אנגלית, עברית (RTL) וצרפתית",
    fr: "Le site web s'efforce de se conformer aux exigences de la norme israélienne 5568 pour l'accessibilité des contenus web, basée sur les directives WCAG 2.1 au niveau AA.\n\nLes ajustements d'accessibilité mis en œuvre sur ce site comprennent :\n• Lien \"Aller au contenu principal\" pour les utilisateurs au clavier\n• Points de repère ARIA (header, main, footer, navigation) pour la navigation des lecteurs d'écran\n• Alternatives textuelles pour les contenus non textuels (images et vidéo décoratifs masqués aux lecteurs d'écran)\n• Navigation complète au clavier pour tous les éléments interactifs, y compris la navigation, les formulaires, le carrousel d'images et la notation par étoiles\n• Contraste de couleurs suffisant (≥4.5:1) pour tout le texte de corps et les étiquettes d'interface\n• Attribut de langue (lang) et direction du texte (dir) mis à jour dynamiquement selon la langue sélectionnée, avec support complet de droite à gauche (RTL) pour l'hébreu\n• Redimensionnement du texte sans perte de contenu ou de fonctionnalité\n• Navigation claire et cohérente avec des noms accessibles sur tous les boutons et contrôles\n• Étiquettes ARIA descriptives sur la navigation du carrousel d'images et les indicateurs d'images de propriétés\n• Notation par étoiles implémentée comme groupe de boutons radio pour une compatibilité complète avec les technologies d'assistance\n• Champs de formulaire avec étiquettes visibles\n• Support multilingue : anglais, hébreu (RTL) et français",
  },
  accessibilitySection2Title: {
    en: "2. Known Limitations",
    he: "2. מגבלות ידועות",
    fr: "2. Limitations Connues",
  },
  accessibilitySection2Content: {
    en: "Despite our efforts, some content on the website may not yet be fully accessible. We are continuously working to improve the accessibility of our site.\n\nAreas we are still working on:\n• Gallery images showing properties and locations in Israel are labeled with a sequence number; individual descriptive captions are not yet available\n• Certain third-party embedded content (such as maps) may not be fully accessible",
    he: "למרות מאמצינו, ייתכן שחלק מהתכנים באתר עדיין אינם נגישים במלואם. אנו עובדים ברציפות על שיפור הנגישות של האתר.\n\nתחומים עליהם אנו עדיין עובדים:\n• תמונות הגלריה המציגות נכסים ואתרים בישראל מסומנות במספר רץ; כיתובים תיאוריים נפרדים אינם זמינים עדיין\n• תכנים מסוימים המוטמעים מגורמים חיצוניים (כגון מפות) עשויים שלא להיות נגישים במלואם",
    fr: "Malgré nos efforts, certains contenus du site web peuvent ne pas encore être entièrement accessibles. Nous travaillons continuellement à améliorer l'accessibilité de notre site.\n\nDomaines sur lesquels nous travaillons encore :\n• Les images de la galerie montrant des propriétés et des lieux en Israël sont étiquetées avec un numéro de séquence ; des légendes descriptives individuelles ne sont pas encore disponibles\n• Certains contenus tiers intégrés (comme les cartes) peuvent ne pas être entièrement accessibles",
  },
  accessibilitySection3Title: {
    en: "3. Accessibility Assistance",
    he: "3. סיוע בנגישות",
    fr: "3. Assistance en Matière d'Accessibilité",
  },
  accessibilitySection3Content: {
    en: "If you experience any difficulty accessing content on this website, please contact us:\n\n• Phone: +972-50-236-4585\n• Email: samantha@realestate-in-israel.com\n\nPlease describe the page you were trying to access and the nature of the difficulty. We will do our best to provide the information in an accessible format or through an alternative channel.",
    he: "אם נתקלתם בקושי כלשהו בגישה לתכנים באתר זה, אנא צרו איתנו קשר:\n\n• טלפון: 972-50-236-4585+\n• אימייל: samantha@realestate-in-israel.com\n\nאנא תארו את הדף אליו ניסיתם לגשת ואת אופי הקושי. נעשה כמיטב יכולתנו לספק את המידע בפורמט נגיש או דרך ערוץ חלופי.",
    fr: "Si vous éprouvez des difficultés à accéder au contenu de ce site web, veuillez nous contacter :\n\n• Téléphone : +972-50-236-4585\n• E-mail : samantha@realestate-in-israel.com\n\nVeuillez décrire la page à laquelle vous tentiez d'accéder et la nature de la difficulté. Nous ferons de notre mieux pour fournir les informations dans un format accessible ou par un canal alternatif.",
  },
  accessibilitySection4Title: {
    en: "4. Formal Complaints",
    he: "4. פניות רשמיות",
    fr: "4. Plaintes Formelles",
  },
  accessibilitySection4Content: {
    en: "If you are not satisfied with our response to your accessibility request, you may contact the Commission for Equal Rights of Persons with Disabilities at the Ministry of Justice.",
    he: "אם אינכם מרוצים מהתגובה לפנייתכם בנושא נגישות, תוכלו לפנות לנציבות שוויון זכויות לאנשים עם מוגבלות במשרד המשפטים.",
    fr: "Si vous n'êtes pas satisfait de notre réponse à votre demande d'accessibilité, vous pouvez contacter la Commission pour l'égalité des droits des personnes handicapées au Ministère de la Justice.",
  },

  // Common
  loading: {
    en: "Loading...",
    he: "טוען...",
    fr: "Chargement...",
  },
  error: {
    en: "Error",
    he: "שגיאה",
    fr: "Erreur",
  },
  noProperties: {
    en: "No properties found matching your criteria.",
    he: "לא נמצאו נכסים התואמים לקריטריונים שלך.",
    fr: "Aucune propriété trouvée correspondant à vos critères.",
  },
  tryAdjustingFilters: {
    en: "Try adjusting your filters or contact us directly.",
    he: "נסה לשנות את הסינון או צור איתנו קשר ישירות.",
    fr: "Essayez d'ajuster vos filtres ou contactez-nous directement.",
  },

  // App-level messages
  errorLoadingPropertiesTitle: {
    en: "Error Loading Properties",
    he: "שגיאה בטעינת נכסים",
    fr: "Erreur lors du chargement des propriétés",
  },
  errorLoadingPropertiesMessage: {
    en: "Please try again later or contact support.",
    he: "אנא נסו שוב מאוחר יותר או פנו לתמיכה.",
    fr: "Veuillez réessayer plus tard ou contacter le support.",
  },

  // Cities
  telAviv: {
    en: "Tel Aviv",
    he: "תל אביב",
    fr: "Tel Aviv",
  },
  jerusalem: {
    en: "Jerusalem",
    he: "ירושלים",
    fr: "Jérusalem",
  },
  haifa: {
    en: "Haifa",
    he: "חיפה",
    fr: "Haïfa",
  },
  herzliya: {
    en: "Herzliya",
    he: "הרצליה",
    fr: "Herzliya",
  },
  netanya: {
    en: "Netanya",
    he: "נתניה",
    fr: "Netanya",
  },
  ashdod: {
    en: "Ashdod",
    he: "אשדוד",
    fr: "Ashdod",
  },
  raMat: {
    en: "Ramat Gan",
    he: "רמת גן",
    fr: "Ramat Gan",
  },

  // Agent Profile
  agentName: {
    en: "Samantha Azoulay",
    he: "סמנטה אזולאי",
    fr: "Samantha Azoulay",
  },
  meetYourAgent: {
    en: "Meet Your Agent",
    he: "הכירו את הסוכנת שלכם",
    fr: "Rencontrez Votre Agent",
  },
  agentIntro: {
    en: "Your trusted partner in finding the perfect property in Israel",
    he: "השותפה המהימנה שלכם במציאת הנכס המושלם בישראל",
    fr: "Votre partenaire de confiance pour trouver la propriété parfaite en Israël",
  },
  agentTitle: {
    en: "Licensed Real Estate Agent & Aliyah Specialist",
    he: 'מתווכת נדל"ן מורשית ומומחית עלייה',
    fr: "Agent Immobilier Licencié et Spécialiste de l'Aliyah",
  },
  agentDescription: {
    en: "With over 10 years of experience helping families make Aliyah and find their perfect home in Israel, Samantha specializes in premium properties across the country. She speaks Hebrew, English, and French.",
    he: "עם למעלה מ-10 שנות ניסיון בעזרה למשפחות לעשות עלייה ולמצוא את הבית המושלם בישראל, סמנטה מתמחה בנכסי פרימיום ברחבי הארץ. דוברת עברית, אנגלית וצרפתית.",
    fr: "Avec plus de 10 ans d'expérience aidant les familles à faire leur Aliyah et à trouver leur maison parfaite en Israël, Samantha se spécialise dans les propriétés premium à travers le pays. Elle parle hébreu, anglais et français.",
  },
  callNow: {
    en: "Call Now",
    he: "התקשר עכשיו",
    fr: "Appeler Maintenant",
  },
  sendEmail: {
    en: "Send Email",
    he: "שלח אימייל",
    fr: "Envoyer Email",
  },
  whatsapp: {
    en: "WhatsApp",
    he: "וואטסאפ",
    fr: "WhatsApp",
  },
  whatsappContact: {
    en: "Contact us on WhatsApp",
    he: "צרו קשר בוואטסאפ",
    fr: "Contactez-nous sur WhatsApp",
  },
  chatWithUsWhatsApp: {
    en: "Chat with us on WhatsApp",
    he: "שוחחו איתנו בוואטסאפ",
    fr: "Discutez avec nous sur WhatsApp",
  },

  // Additional Testimonials
  shareTestimonial: {
    en: "Share Your Experience",
    he: "שתף את החוויה שלך",
    fr: "Partagez Votre Expérience",
  },
  submitTestimonial: {
    en: "Submit Testimonial",
    he: "שלח המלצה",
    fr: "Soumettre Témoignage",
  },
  testimonialName: {
    en: "Your Name",
    he: "השם שלך",
    fr: "Votre Nom",
  },
  testimonialEmail: {
    en: "Your Email",
    he: "האימייל שלך",
    fr: "Votre Email",
  },
  testimonialMessage: {
    en: "Your Testimonial",
    he: "ההמלצה שלך",
    fr: "Votre Témoignage",
  },
  testimonialRating: {
    en: "Your Rating",
    he: "הדירוג שלך",
    fr: "Votre Note",
  },
  testimonialPlaceholder: {
    en: "Share your experience working with Samantha...",
    he: "שתף את החוויה שלך בעבודה עם סמנטה...",
    fr: "Partagez votre expérience de travail avec Samantha...",
  },
  testimonialSubmitted: {
    en: "Thank you! Your testimonial has been submitted for review.",
    he: "תודה! ההמלצה שלך נשלחה לבדיקה.",
    fr: "Merci! Votre témoignage a été soumis pour examen.",
  },
  testimonialError: {
    en: "Error submitting testimonial. Please try again.",
    he: "שגיאה בשליחת ההמלצה. אנא נסה שוב.",
    fr: "Erreur lors de la soumission du témoignage. Veuillez réessayer.",
  },
  testimonialDescription: {
    en: "Share your experience working with Samantha and help others make informed decisions.",
    he: "שתף את החוויה שלך בעבודה עם סמנטה ועזור לאחרים לקבל החלטות מושכלות.",
    fr: "Partagez votre expérience de travail avec Samantha et aidez les autres à prendre des décisions éclairées.",
  },
  testimonialSeeExperiences: {
    en: "See what our clients say about their experience",
    he: "ראה מה הלקוחות שלנו אומרים על החוויה שלהם",
    fr: "Voyez ce que nos clients disent de leur expérience",
  },
  testimonialBeFirst: {
    en: "Be the first to share your experience!",
    he: "היה הראשון לשתף את החוויה שלך!",
    fr: "Soyez le premier à partager votre expérience!",
  },
  testimonialRealExperiences: {
    en: "Real experiences from our satisfied clients",
    he: "חוויות אמיתיות מהלקוחות המרוצים שלנו",
    fr: "Expériences réelles de nos clients satisfaits",
  },
  privacyPolicyAgreement: {
    en: "I agree to the",
    he: "אני מסכים ל",
    fr: "J'accepte la",
  },
  privacyPolicyText: {
    en: "privacy policy",
    he: "מדיניות הפרטיות",
    fr: "politique de confidentialité",
  },
  andText: {
    en: "and",
    he: "ול",
    fr: "et les",
  },
  termsOfServiceText: {
    en: "terms of service",
    he: "תנאי השירות",
    fr: "conditions de service",
  },
  privacyPolicyRequired: {
    en: "You must agree to the privacy policy to submit your testimonial",
    he: "עליך להסכים למדיניות הפרטיות כדי לשלוח את ההמלצה שלך",
    fr: "Vous devez accepter la politique de confidentialité pour soumettre votre témoignage",
  },
  manageTestimonials: {
    en: "Manage Testimonials",
    he: "נהל המלצות",
    fr: "Gérer Témoignages",
  },
  pendingTestimonials: {
    en: "Pending Testimonials",
    he: "המלצות ממתינות",
    fr: "Témoignages en Attente",
  },
  approvedTestimonials: {
    en: "Approved Testimonials",
    he: "המלצות מאושרות",
    fr: "Témoignages Approuvés",
  },
  approve: {
    en: "Approve",
    he: "אשר",
    fr: "Approuver",
  },
  reject: {
    en: "Reject",
    he: "דחה",
    fr: "Rejeter",
  },
  delete: {
    en: "Delete",
    he: "מחק",
    fr: "Supprimer",
  },
  noTestimonials: {
    en: "No testimonials yet",
    he: "עדיין אין המלצות",
    fr: "Aucun témoignage pour le moment",
  },

  // Admin Panel Translations
  adminPanel: {
    en: "Admin Panel",
    he: "פאנל ניהול",
    fr: "Panneau d'Administration",
  },
  realEstateAdmin: {
    en: "Real Estate Admin",
    he: 'ניהול נדל"ן',
    fr: "Administration Immobilière",
  },
  contacts: {
    en: "Contacts",
    he: "פניות",
    fr: "Contacts",
  },
  addProperty: {
    en: "Add Property",
    he: "הוסף נכס",
    fr: "Ajouter Propriété",
  },
  viewSite: {
    en: "View Site",
    he: "צפה באתר",
    fr: "Voir le Site",
  },
  logout: {
    en: "Logout",
    he: "התנתק",
    fr: "Déconnexion",
  },
  signInToManageProperties: {
    en: "Sign in to manage properties",
    he: "התחבר כדי לנהל נכסים",
    fr: "Connectez-vous pour gérer les propriétés",
  },
  username: {
    en: "Username",
    he: "שם משתמש",
    fr: "Nom d'utilisateur",
  },
  password: {
    en: "Password",
    he: "סיסמה",
    fr: "Mot de passe",
  },
  enterUsername: {
    en: "Enter your username",
    he: "הכנס שם משתמש",
    fr: "Entrez votre nom d'utilisateur",
  },
  enterPassword: {
    en: "Enter your password",
    he: "הכנס סיסמה",
    fr: "Entrez votre mot de passe",
  },
  signIn: {
    en: "Sign In",
    he: "התחבר",
    fr: "Se Connecter",
  },
  signingIn: {
    en: "Signing in...",
    he: "מתחבר...",
    fr: "Connexion...",
  },
  invalidCredentials: {
    en: "Invalid username or password",
    he: "שם משתמש או סיסמה שגויים",
    fr: "Nom d'utilisateur ou mot de passe invalide",
  },
  language: {
    en: "Language",
    he: "שפה",
    fr: "Langue",
  },
  createProperty: {
    en: "Create Property",
    he: "צור נכס",
    fr: "Créer Propriété",
  },
  editProperty: {
    en: "Edit Property",
    he: "ערוך נכס",
    fr: "Modifier Propriété",
  },
  save: {
    en: "Save",
    he: "שמור",
    fr: "Enregistrer",
  },
  cancel: {
    en: "Cancel",
    he: "בטל",
    fr: "Annuler",
  },
  title: {
    en: "Title",
    he: "כותרת",
    fr: "Titre",
  },
  description: {
    en: "Description",
    he: "תיאור",
    fr: "Description",
  },
  address: {
    en: "Address",
    he: "כתובת",
    fr: "Adresse",
  },
  area: {
    en: "Area (sqm)",
    he: 'שטח (מ"ר)',
    fr: "Superficie (m²)",
  },
  images: {
    en: "Images",
    he: "תמונות",
    fr: "Images",
  },
  edit: {
    en: "Edit",
    he: "ערוך",
    fr: "Modifier",
  },
  confirmDelete: {
    en: "Are you sure you want to delete this property?",
    he: "האם אתה בטוח שברצונך למחוק נכס זה?",
    fr: "Êtes-vous sûr de vouloir supprimer cette propriété?",
  },
  noPropertiesFound: {
    en: "No properties found",
    he: "לא נמצאו נכסים",
    fr: "Aucune propriété trouvée",
  },
  loadingProperties: {
    en: "Loading properties...",
    he: "טוען נכסים...",
    fr: "Chargement des propriétés...",
  },
  errorLoadingProperties: {
    en: "Error loading properties",
    he: "שגיאה בטעינת נכסים",
    fr: "Erreur lors du chargement des propriétés",
  },
  contactDetails: {
    en: "Contact Details",
    he: "פרטי יצירת קשר",
    fr: "Détails de Contact",
  },
  submittedAt: {
    en: "Submitted at",
    he: "נשלח ב",
    fr: "Soumis le",
  },
  markAsRead: {
    en: "Mark as Read",
    he: "סמן כנקרא",
    fr: "Marquer comme Lu",
  },
  markAsUnread: {
    en: "Mark as Unread",
    he: "סמן כלא נקרא",
    fr: "Marquer comme Non Lu",
  },
  noContactsFound: {
    en: "No contacts found",
    he: "לא נמצאו פניות",
    fr: "Aucun contact trouvé",
  },
  noContactMessages: {
    en: "No contact messages have been received yet.",
    he: "עדיין לא התקבלו הודעות קשר.",
    fr: "Aucun message de contact n'a encore été reçu.",
  },
  tryAdjustingSearchTerms: {
    en: "Try adjusting your search terms.",
    he: "נסה להתאים את מונחי החיפוש שלך.",
    fr: "Essayez d'ajuster vos termes de recherche.",
  },
  loadingContacts: {
    en: "Loading contacts...",
    he: "טוען פניות...",
    fr: "Chargement des contacts...",
  },
  errorLoadingContacts: {
    en: "Error loading contacts",
    he: "שגיאה בטעינת פניות",
    fr: "Erreur lors du chargement des contacts",
  },
  backToProperties: {
    en: "Back to Properties",
    he: "חזור לנכסים",
    fr: "Retour aux Propriétés",
  },
  addNewProperty: {
    en: "Add New Property",
    he: "הוסף נכס חדש",
    fr: "Ajouter Nouvelle Propriété",
  },
  updatePropertyDetails: {
    en: "Update property details",
    he: "עדכן פרטי הנכס",
    fr: "Mettre à jour les détails de la propriété",
  },
  createNewPropertyListing: {
    en: "Create a new property listing",
    he: "צור רישום נכס חדש",
    fr: "Créer une nouvelle annonce immobilière",
  },
  updateProperty: {
    en: "Update Property",
    he: "עדכן נכס",
    fr: "Mettre à jour la Propriété",
  },
  saving: {
    en: "Saving...",
    he: "שומר...",
    fr: "Enregistrement...",
  },
  totalContacts: {
    en: "Total Contacts",
    he: "סך כל הפניות",
    fr: "Total des Contacts",
  },
  unreadMessages: {
    en: "Unread Messages",
    he: "הודעות שלא נקראו",
    fr: "Messages Non Lus",
  },
  recentContacts: {
    en: "Recent (30 days)",
    he: "אחרונות (30 יום)",
    fr: "Récent (30 jours)",
  },
  filtersAndSearch: {
    en: "Filters & Search",
    he: "סינון וחיפוש",
    fr: "Filtres et Recherche",
  },
  searchContacts: {
    en: "Search contacts...",
    he: "חפש פניות...",
    fr: "Rechercher des contacts...",
  },
  filterByStatus: {
    en: "Filter by status",
    he: "סנן לפי סטטוס",
    fr: "Filtrer par statut",
  },
  allMessages: {
    en: "All Messages",
    he: "כל ההודעות",
    fr: "Tous les Messages",
  },
  unreadOnly: {
    en: "Unread Only",
    he: "לא נקרא בלבד",
    fr: "Non Lu Seulement",
  },
  readOnly: {
    en: "Read Only",
    he: "נקרא בלבד",
    fr: "Lu Seulement",
  },
  contactMessages: {
    en: "Contact Messages",
    he: "הודעות קשר",
    fr: "Messages de Contact",
  },
  propertyListings: {
    en: "Property Listings",
    he: "רישומי נכסים",
    fr: "Annonces Immobilières",
  },
  actions: {
    en: "Actions",
    he: "פעולות",
    fr: "Actions",
  },
  location: {
    en: "Location",
    he: "מיקום",
    fr: "Emplacement",
  },
  property: {
    en: "Property",
    he: "נכס",
    fr: "Propriété",
  },
  size: {
    en: "Size",
    he: "גודל",
    fr: "Taille",
  },
  addFirstProperty: {
    en: "Add First Property",
    he: "הוסף נכס ראשון",
    fr: "Ajouter Première Propriété",
  },
  getStartedMessage: {
    en: "Get started by creating your first property listing.",
    he: "התחל על ידי יצירת רישום הנכס הראשון שלך.",
    fr: "Commencez par créer votre première annonce immobilière.",
  },
  managePropertyListings: {
    en: "Manage your property listings",
    he: "נהל את רישומי הנכסים שלך",
    fr: "Gérez vos annonces immobilières",
  },
  total: {
    en: "total",
    he: 'סה"כ',
    fr: "total",
  },
  pending: {
    en: "Pending",
    he: "ממתין",
    fr: "En attente",
  },
  approved: {
    en: "Approved",
    he: "אושר",
    fr: "Approuvé",
  },
  rejected: {
    en: "Rejected",
    he: "נדחה",
    fr: "Rejeté",
  },
  failedToUpdateTestimonial: {
    en: "Failed to update testimonial status",
    he: "נכשל בעדכון סטטוס ההמלצה",
    fr: "Échec de la mise à jour du statut du témoignage",
  },
  failedToDeleteTestimonial: {
    en: "Failed to delete testimonial",
    he: "נכשל במחיקת ההמלצה",
    fr: "Échec de la suppression du témoignage",
  },
  rating: {
    en: "Rating",
    he: "דירוג",
    fr: "Note",
  },
  submittedOn: {
    en: "Submitted on",
    he: "נשלח ב",
    fr: "Soumis le",
  },
  noTestimonialsInCategory: {
    en: "No testimonials in this category yet.",
    he: "עדיין אין המלצות בקטגוריה זו.",
    fr: "Aucun témoignage dans cette catégorie pour le moment.",
  },
  confirmDeleteTestimonial: {
    en: "Are you sure you want to delete this testimonial? This action cannot be undone.",
    he: "האם אתה בטוח שברצונך למחוק המלצה זו? פעולה זו לא ניתנת לביטול.",
    fr: "Êtes-vous sûr de vouloir supprimer ce témoignage ? Cette action ne peut pas être annulée.",
  },
  deleteTestimonial: {
    en: "Delete Testimonial",
    he: "מחק המלצה",
    fr: "Supprimer le Témoignage",
  },
  rejectedTestimonials: {
    en: "Rejected Testimonials",
    he: "המלצות שנדחו",
    fr: "Témoignages Rejetés",
  },
  viewAll: {
    en: "View All",
    he: "צפה בהכל",
    fr: "Voir Tout",
  },
  basicInformation: {
    en: "Basic Information",
    he: "מידע בסיסי",
    fr: "Informations de Base",
  },
  multiLanguageContent: {
    en: "Multi-Language Content",
    he: "תוכן רב לשוני",
    fr: "Contenu Multilingue",
  },
  locationDetails: {
    en: "Location Details",
    he: "פרטי מיקום",
    fr: "Détails de l'Emplacement",
  },
  propertyDetails: {
    en: "Property Details",
    he: "פרטי הנכס",
    fr: "Détails de la Propriété",
  },
  mediaGallery: {
    en: "Media Gallery",
    he: "גלריית מדיה",
    fr: "Galerie Média",
  },
  titleInEnglish: {
    en: "Title (English)",
    he: "כותרת (אנגלית)",
    fr: "Titre (Anglais)",
  },
  titleInHebrew: {
    en: "Title (Hebrew)",
    he: "כותרת (עברית)",
    fr: "Titre (Hébreu)",
  },
  titleInFrench: {
    en: "Title (French)",
    he: "כותרת (צרפתית)",
    fr: "Titre (Français)",
  },
  descriptionInEnglish: {
    en: "Description (English)",
    he: "תיאור (אנגלית)",
    fr: "Description (Anglais)",
  },
  descriptionInHebrew: {
    en: "Description (Hebrew)",
    he: "תיאור (עברית)",
    fr: "Description (Hébreu)",
  },
  descriptionInFrench: {
    en: "Description (French)",
    he: "תיאור (צרפתית)",
    fr: "Description (Français)",
  },
  cityInEnglish: {
    en: "City (English)",
    he: "עיר (אנגלית)",
    fr: "Ville (Anglais)",
  },
  cityInHebrew: {
    en: "City (Hebrew)",
    he: "עיר (עברית)",
    fr: "Ville (Hébreu)",
  },
  cityInFrench: {
    en: "City (French)",
    he: "עיר (צרפתית)",
    fr: "Ville (Français)",
  },
  neighborhoodInEnglish: {
    en: "Neighborhood (English)",
    he: "שכונה (אנגלית)",
    fr: "Quartier (Anglais)",
  },
  neighborhoodInHebrew: {
    en: "Neighborhood (Hebrew)",
    he: "שכונה (עברית)",
    fr: "Quartier (Hébreu)",
  },
  neighborhoodInFrench: {
    en: "Neighborhood (French)",
    he: "שכונה (צרפתית)",
    fr: "Quartier (Français)",
  },
  neighborhood: {
    en: "Neighborhood",
    he: "שכונה",
    fr: "Quartier",
  },
  latitude: {
    en: "Latitude",
    he: "קו רוחב",
    fr: "Latitude",
  },
  longitude: {
    en: "Longitude",
    he: "קו אורך",
    fr: "Longitude",
  },
  currency: {
    en: "Currency",
    he: "מטבע",
    fr: "Devise",
  },
  forSaleType: {
    en: "For Sale",
    he: "למכירה",
    fr: "À Vendre",
  },
  forRentType: {
    en: "For Rent",
    he: "להשכרה",
    fr: "À Louer",
  },
  availableStatus: {
    en: "Available",
    he: "זמין",
    fr: "Disponible",
  },
  soldStatus: {
    en: "Sold",
    he: "נמכר",
    fr: "Vendu",
  },
  rentedStatus: {
    en: "Rented",
    he: "מושכר",
    fr: "Loué",
  },
  uploadImages: {
    en: "Upload Images",
    he: "העלה תמונות",
    fr: "Télécharger des Images",
  },
  dragDropImages: {
    en: "Drag and drop images here, or click to select files",
    he: "גרור ושחרר תמונות כאן, או לחץ לבחירת קבצים",
    fr: "Glissez et déposez des images ici, ou cliquez pour sélectionner des fichiers",
  },
  removeImage: {
    en: "Remove image",
    he: "הסר תמונה",
    fr: "Supprimer l'image",
  },
  propertyImages: {
    en: "Property Images",
    he: "תמונות נכס",
    fr: "Images de Propriété",
  },
  propertyVideo: {
    en: "Property Video",
    he: "וידאו נכס",
    fr: "Vidéo de Propriété",
  },
  uploadVideo: {
    en: "Upload Video",
    he: "העלה וידאו",
    fr: "Télécharger une Vidéo",
  },
  featuresCommaSeparated: {
    en: "Features (comma-separated)",
    he: "מאפיינים (מופרדים בפסיק)",
    fr: "Caractéristiques (séparées par des virgules)",
  },
  sizeSquareMeters: {
    en: "Size (m²)",
    he: 'גודל (מ"ר)',
    fr: "Taille (m²)",
  },
  price: {
    en: "Price",
    he: "מחיר",
    fr: "Prix",
  },
  testimonials: {
    en: "Testimonials",
    he: "המלצות",
    fr: "Témoignages",
  },

  // Privacy Policy Content
  privacyPolicyTitle: {
    en: "Privacy Policy - Real Estate Website",
    he: 'מדיניות פרטיות – אתר נדל"ן',
    fr: "Politique de Confidentialité - Site Immobilier",
  },
  privacyPolicyLastUpdated: {
    en: "Last updated: 17/08/2025",
    he: "עודכן לאחרונה: 17/08/2025",
    fr: "Dernière mise à jour : 17/08/2025",
  },
  privacyPolicyIntro: {
    en: "This website is operated by Samantha Azoulay, licensed real estate agent, and deals with marketing, brokerage and advertising of real estate properties. We are committed to protecting user privacy in accordance with applicable privacy laws.",
    he: 'האתר מופעל על ידי סמנטה אזולאי, סוכנת נדל"ן מוסמכת, ועוסק בשיווק, תיווך ופרסום נכסי נדל"ן. אנו מחויבים לשמירה על פרטיות המשתמשים בהתאם לחוק הגנת הפרטיות, התשמ"א–1981, ולתיקון 13 לחוק.',
    fr: "Ce site web est exploité par Samantha Azoulay, agent immobilier agréé, et traite du marketing, du courtage et de la publicité de propriétés immobilières. Nous nous engageons à protéger la vie privée des utilisateurs conformément aux lois applicables sur la protection des données.",
  },
  privacyPolicySection1Title: {
    en: "1. What Information Do We Collect?",
    he: "1. איזה מידע נאסף?",
    fr: "1. Quelles Informations Collectons-Nous ?",
  },
  privacyPolicySection1Content: {
    en: "When using the website, we may collect the following information:\n• Full name\n• Email address\n• Phone number\n• Inquiry or review content\n• Real estate preferences (location, budget, property type)\n• Technical information (IP address, browser type, geographic location)",
    he: 'בעת שימוש באתר, ייתכן שנאסוף את המידע הבא:\n• שם מלא\n• כתובת דוא"ל\n• מספר טלפון\n• תוכן פנייה או ביקורת\n• העדפות נדל"ן (מיקום, תקציב, סוג נכס)\n• מידע טכני (כתובת IP, סוג דפדפן, מיקום גיאוגרפי)',
    fr: "Lors de l'utilisation du site web, nous pouvons collecter les informations suivantes :\n• Nom complet\n• Adresse e-mail\n• Numéro de téléphone\n• Contenu des demandes ou avis\n• Préférences immobilières (emplacement, budget, type de propriété)\n• Informations techniques (adresse IP, type de navigateur, localisation géographique)",
  },
  privacyPolicySection2Title: {
    en: "2. Purposes of Information Use",
    he: "2. מטרות השימוש במידע",
    fr: "2. Finalités d'Utilisation des Informations",
  },
  privacyPolicySection2Content: {
    en: "• Contacting the user\n• Matching relevant properties\n• Improving service and user experience\n• Publishing reviews on the website (subject to approval)\n• Internal statistical analysis",
    he: "• יצירת קשר עם המשתמש\n• התאמת נכסים רלוונטיים\n• שיפור השירות וחוויית המשתמש\n• פרסום ביקורות באתר (בכפוף לאישור)\n• ניתוח סטטיסטי פנימי",
    fr: "• Contacter l'utilisateur\n• Adapter les propriétés pertinentes\n• Améliorer le service et l'expérience utilisateur\n• Publier des avis sur le site web (sous réserve d'approbation)\n• Analyse statistique interne",
  },
  privacyPolicySection3Title: {
    en: "3. Sharing Information with Third Parties",
    he: "3. שיתוף מידע עם צדדים שלישיים",
    fr: "3. Partage d'Informations avec des Tiers",
  },
  privacyPolicySection3Content: {
    en: "Information may be transferred to the following parties:\n• Property owners or brokers for property matching purposes\n• Technology service providers (such as CRM systems, cloud storage)\n• Law enforcement authorities, if required by law",
    he: "המידע עשוי להועבר לגורמים הבאים:\n• בעלי נכסים או מתווכים לצורך התאמת נכסים\n• ספקי שירותים טכנולוגיים (כגון מערכת CRM, אחסון בענן)\n• רשויות החוק, אם נדרש לפי דין",
    fr: "Les informations peuvent être transférées aux parties suivantes :\n• Propriétaires ou courtiers pour l'adaptation des propriétés\n• Fournisseurs de services technologiques (tels que systèmes CRM, stockage en nuage)\n• Autorités judiciaires, si requis par la loi",
  },
  privacyPolicySection4Title: {
    en: "4. Information Security",
    he: "4. אבטחת מידע",
    fr: "4. Sécurité des Informations",
  },
  privacyPolicySection4Content: {
    en: "The website uses HTTPS protocol. Information is stored on secure servers, with limited access to authorized employees only.",
    he: "האתר משתמש בפרוטוקול HTTPS. המידע נשמר בשרתים מאובטחים, עם גישה מוגבלת לעובדים מורשים בלבד.",
    fr: "Le site web utilise le protocole HTTPS. Les informations sont stockées sur des serveurs sécurisés, avec un accès limité aux employés autorisés uniquement.",
  },
  privacyPolicySection5Title: {
    en: "5. User Rights",
    he: "5. זכויות המשתמש",
    fr: "5. Droits de l'Utilisateur",
  },
  privacyPolicySection5Content: {
    en: "Users have the right to:\n• Request access to information stored about them\n• Request correction or deletion of personal information\n• Object to processing of information for marketing purposes\n\nRequests can be sent to: [contact email address]",
    he: "המשתמש רשאי:\n• לבקש עיון במידע שנשמר עליו\n• לבקש תיקון או מחיקה של מידע אישי\n• להתנגד לעיבוד מידע לצרכים שיווקיים\n\nבקשות ניתן לשלוח לכתובת: [כתובת אימייל ליצירת קשר]",
    fr: "Les utilisateurs ont le droit de :\n• Demander l'accès aux informations stockées à leur sujet\n• Demander la correction ou la suppression d'informations personnelles\n• S'opposer au traitement d'informations à des fins marketing\n\nLes demandes peuvent être envoyées à : [adresse e-mail de contact]",
  },

  // Terms of Use Content
  termsOfUseTitle: {
    en: "Terms of Use - Samantha Azoulay Real Estate Website",
    he: 'תנאי שימוש באתר סמנטה אזולאי נדל"ן',
    fr: "Conditions d'Utilisation - Site Web Samantha Azoulay Immobilier",
  },
  termsOfUseLastUpdated: {
    en: "Last updated: 17/08/2025",
    he: "עודכן לאחרונה: 17/08/2025",
    fr: "Dernière mise à jour : 17/08/2025",
  },
  termsOfUseIntro: {
    en: "Welcome to the Samantha Azoulay Real Estate website, operated by Samantha Azoulay, licensed real estate agent. The website is designed to present real estate properties, projects, marketing information, and to enable contact with Samantha Azoulay for real estate services.\n\nUse of the website is subject to the terms detailed below. Using the website constitutes agreement by the user to these terms.",
    he: 'ברוכים הבאים לאתר סמנטה אזולאי נדל"ן, המופעל על ידי סמנטה אזולאי, סוכנת נדל"ן מוסמכת. האתר נועד להציג נכסי נדל"ן, פרויקטים, מידע שיווקי, ולאפשר יצירת קשר עם סמנטה אזולאי לצורך קבלת שירותים בתחום הנדל"ן.\n\nהשימוש באתר כפוף לתנאים המפורטים להלן. השימוש באתר מהווה הסכמה מצד המשתמש לתנאים אלה.',
    fr: "Bienvenue sur le site web Samantha Azoulay Immobilier, exploité par Samantha Azoulay, agent immobilier agréé. Le site web est conçu pour présenter des propriétés immobilières, des projets, des informations marketing, et permettre le contact avec Samantha Azoulay pour des services immobiliers.\n\nL'utilisation du site web est soumise aux conditions détaillées ci-dessous. L'utilisation du site web constitue un accord de l'utilisateur à ces conditions.",
  },
  termsOfUseSection1Title: {
    en: "1. Website Use",
    he: "1. שימוש באתר",
    fr: "1. Utilisation du Site Web",
  },
  termsOfUseSection1Content: {
    en: "• The website is intended for private users to obtain information about real estate properties.\n• Commercial, technical or automated use of website content is prohibited without prior written permission from Samantha Azoulay.\n• Copying, distributing, modifying or publishing content from the website without permission is prohibited.",
    he: '• האתר מיועד למשתמשים פרטיים לצורך קבלת מידע על נכסי נדל"ן.\n• אין לעשות שימוש מסחרי, טכני או אוטומטי בתכני האתר ללא אישור מראש ובכתב מסמנטה אזולאי.\n• אין להעתיק, להפיץ, לשנות או לפרסם תכנים מהאתר ללא רשות.',
    fr: "• Le site web est destiné aux utilisateurs privés pour obtenir des informations sur les propriétés immobilières.\n• L'utilisation commerciale, technique ou automatisée du contenu du site web est interdite sans autorisation écrite préalable de Samantha Azoulay.\n• La copie, la distribution, la modification ou la publication de contenu du site web sans autorisation est interdite.",
  },
  termsOfUseSection2Title: {
    en: "2. Property Listings",
    he: "2. פרסום נכסים",
    fr: "2. Annonces de Propriétés",
  },
  termsOfUseSection2Content: {
    en: "• Every property, image or marketing information on the website was provided with the approval of property owners or their representatives.\n• Information on the website is for illustration purposes only and does not constitute a commitment or binding offer.\n• Property details, availability or prices may change without prior notice.",
    he: "• כל נכס, תמונה או מידע שיווקי באתר נמסרו באישור בעלי הנכס או נציגיהם.\n• המידע באתר נועד לצורכי המחשה בלבד ואינו מהווה התחייבות או הצעה מחייבת.\n• ייתכנו שינויים בפרטי הנכסים, זמינותם או מחירם ללא הודעה מוקדמת.",
    fr: "• Chaque propriété, image ou information marketing sur le site web a été fournie avec l'approbation des propriétaires ou de leurs représentants.\n• Les informations sur le site web sont à des fins d'illustration uniquement et ne constituent pas un engagement ou une offre contraignante.\n• Les détails, la disponibilité ou les prix des propriétés peuvent changer sans préavis.",
  },
  termsOfUseSection3Title: {
    en: "3. Forms and Reviews",
    he: "3. טפסים וביקורות",
    fr: "3. Formulaires et Avis",
  },
  termsOfUseSection3Content: {
    en: "• Leaving a review or inquiry through the website constitutes agreement to storing and processing the information according to the privacy policy.\n• Reviews may be published on the website after approval by the website administrator.\n• The user is responsible for the content they submit, and commits not to include offensive, false or rights-infringing information.",
    he: "• השארת ביקורת או פנייה דרך האתר מהווה הסכמה לשמירת המידע ולעיבודו בהתאם למדיניות הפרטיות.\n• ביקורות עשויות להתפרסם באתר לאחר אישור מנהלת האתר.\n• המשתמש אחראי לתוכן שהוא שולח, ומתחייב שלא לכלול בו מידע פוגעני, שקרי או מפר זכויות.",
    fr: "• Laisser un avis ou une demande via le site web constitue un accord pour stocker et traiter les informations selon la politique de confidentialité.\n• Les avis peuvent être publiés sur le site web après approbation par l'administrateur du site.\n• L'utilisateur est responsable du contenu qu'il soumet, et s'engage à ne pas inclure d'informations offensantes, fausses ou portant atteinte aux droits.",
  },
  termsOfUseSection4Title: {
    en: "4. Privacy and Information Security",
    he: "4. פרטיות ואבטחת מידע",
    fr: "4. Confidentialité et Sécurité des Informations",
  },
  termsOfUseSection4Content: {
    en: "• The website operates in accordance with applicable privacy laws.\n• Personal information collected through the website will be stored securely and used only for declared purposes.\n• For more information - see the privacy policy.",
    he: '• האתר פועל בהתאם לחוק הגנת הפרטיות, התשמ"א–1981, ולתיקון 13 לחוק.\n• מידע אישי שנאסף דרך האתר יישמר בצורה מאובטחת וישמש רק למטרות המוצהרות.\n• למידע נוסף – ראו את מדיניות הפרטיות.',
    fr: "• Le site web fonctionne conformément aux lois applicables sur la protection des données.\n• Les informations personnelles collectées via le site web seront stockées de manière sécurisée et utilisées uniquement aux fins déclarées.\n• Pour plus d'informations - voir la politique de confidentialité.",
  },
  termsOfUseSection5Title: {
    en: "5. Intellectual Property",
    he: "5. קניין רוחני",
    fr: "5. Propriété Intellectuelle",
  },
  termsOfUseSection5Content: {
    en: "• All copyrights and intellectual property rights in the website, including texts, images, logos and design - are reserved to Samantha Azoulay or to parties who granted her permission to use.\n• Content may not be used without prior written permission.",
    he: "• כל זכויות היוצרים והקניין הרוחני באתר, לרבות טקסטים, תמונות, לוגואים ועיצוב – שמורות לסמנטה אזולאי או לגורמים שהעניקו לה רשות שימוש.\n• אין לעשות שימוש בתכנים ללא אישור מראש ובכתב.",
    fr: "• Tous les droits d'auteur et droits de propriété intellectuelle du site web, y compris les textes, images, logos et design - sont réservés à Samantha Azoulay ou aux parties qui lui ont accordé la permission d'utilisation.\n• Le contenu ne peut pas être utilisé sans autorisation écrite préalable.",
  },
  termsOfUseSection6Title: {
    en: "6. Limitation of Liability",
    he: "6. הגבלת אחריות",
    fr: "6. Limitation de Responsabilité",
  },
  termsOfUseSection6Content: {
    en: "• The website provides general information only, and should not be considered legal, financial or professional advice.\n• Samantha Azoulay will not be liable for direct or indirect damages resulting from use of the website or reliance on information contained therein.",
    he: "• האתר מספק מידע כללי בלבד, ואין לראות בו ייעוץ משפטי, פיננסי או מקצועי.\n• סמנטה אזולאי לא תהיה אחראית לנזקים ישירים או עקיפים שייגרמו כתוצאה מהשימוש באתר או מהסתמכות על המידע שבו.",
    fr: "• Le site web fournit des informations générales uniquement, et ne doit pas être considéré comme un conseil juridique, financier ou professionnel.\n• Samantha Azoulay ne sera pas responsable des dommages directs ou indirects résultant de l'utilisation du site web ou de la confiance accordée aux informations qu'il contient.",
  },
  termsOfUseSection7Title: {
    en: "7. Changes to Terms",
    he: "7. שינויים בתנאים",
    fr: "7. Modifications des Conditions",
  },
  termsOfUseSection7Content: {
    en: "Samantha Azoulay reserves the right to update the terms of use at any time. Use of the website after updating the terms constitutes agreement to the new terms.",
    he: "סמנטה אזולאי שומרת לעצמה את הזכות לעדכן את תנאי השימוש בכל עת. השימוש באתר לאחר עדכון התנאים מהווה הסכמה לתנאים החדשים.",
    fr: "Samantha Azoulay se réserve le droit de mettre à jour les conditions d'utilisation à tout moment. L'utilisation du site web après la mise à jour des conditions constitue un accord aux nouvelles conditions.",
  },

  // Cookie Consent
  cookieConsentTitle: {
    en: "Cookie Settings",
    he: "הגדרות עוגיות",
    fr: "Paramètres des cookies",
  },
  cookieConsentMessage: {
    en: "We use cookies to enhance your browsing experience and analyze our traffic. Your privacy matters to us.",
    he: "אנו משתמשים בעוגיות כדי לשפר את חווית הגלישה שלך ולנתח תנועה באתר. הפרטיות שלך חשובה לנו.",
    fr: "Nous utilisons des cookies pour améliorer votre expérience et analyser notre trafic. Votre vie privée nous importe.",
  },
  cookieConsentAccept: {
    en: "Accept All",
    he: "אישור הכל",
    fr: "Tout accepter",
  },
  cookieConsentDecline: {
    en: "Decline",
    he: "סירוב",
    fr: "Refuser",
  },
  cookieConsentLearnMore: {
    en: "Privacy Policy",
    he: "מדיניות פרטיות",
    fr: "Politique de confidentialité",
  },
};
